import React from 'react';
import { connect } from 'react-redux';
import { Attributes } from '@leverege/ui-attributes';
import { Selection } from '@leverege/ui-redux';
import ZoneVehicleRenderer from "./ZoneVehicleRenderer.js";
import { jsx as _jsx } from "react/jsx-runtime";
class ZoneVehicleLoaderLayer extends React.Component {
  constructor(props) {
    super(props);
    this.lastConvert = {
      items: []
    };
  }
  getItems() {
    const {
      items
    } = this.props;
    const nItems = Array.isArray(items) ? items : items.items;
    if (this.checkPseudoCache(nItems)) {
      return this.lastConvert;
    }
    this.lastConvert = this.addZonesToVehicles(nItems);
    return this.lastConvert;
  }
  addZonesToVehicles(items) {
    const {
      models: {
        lookup
      },
      relationship: {
        blueprint: {
          type
        }
      }
    } = this.props;
    const zoneAttr = Attributes.getAttribute('zone', type);
    return {
      items: items ? items.map(item => {
        const zoneId = zoneAttr.get(item.data);
        const zone = zoneId && lookup[zoneId];
        return {
          ...item,
          zone
        };
      }) : []
    };
  }
  checkPseudoCache(items) {
    let equal = true;
    if (items?.length !== this.lastItems?.length) {
      equal = false;
    } else {
      equal = items?.every((i, index) => i === this.lastItems?.[index]);
    }
    return equal;
  }
  getLayerIdAndType() {
    const {
      relationship: {
        blueprint
      }
    } = this.props;
    return {
      type: blueprint.type,
      id: blueprint.namePlural.toLowerCase()
    };
  }
  render() {
    const items = this.getItems().items;
    return /*#__PURE__*/_jsx(ZoneVehicleRenderer, {
      ...this.props,
      ...this.getLayerIdAndType(),
      items: items
    });
  }
}
export default connect(state => {
  return {
    models: state.models,
    selected: Selection.get(state, 'selected'),
    rollover: Selection.get(state, 'rollover')
  };
})(ZoneVehicleLoaderLayer);